'use client';

import clsx from 'clsx';
import { FooterButton } from '@/components/ui/common/buttons';
import { useTranslation } from 'react-i18next';
import useCookieContext from '@/components/providers/context/cookie-context';

const i18nNamespaces = ['cookie-page'];

export default function CookieManager() {
    const { t } = useTranslation(i18nNamespaces);

    const { showCookieSettings } = useCookieContext();

    return (
        <section className="flex w-full flex-col items-start gap-[8px] sm:gap-[16px]">
            <div className={clsx('j-h4')}>{t('cookieManage.title')}</div>

            <div className={clsx('j-t1')}>{t('cookieManage.info')}</div>

            <FooterButton
                icon={<></>}
                iconSize={[0, 0]}
                iconSize4Mobile={[0, 0]}
                className={clsx('j-t2 mt-[16px] h-[40px] w-auto sm:mt-[8px]')}
                textColor="#000000"
                textHoverColor="#FFFFFF"
                borderColor="#000000"
                boderHoverColor="#000000"
                bgHoverColor="#000000"
                onClick={showCookieSettings}
                text={t('cookieManage.button')}
                withIcon={false}
                keepCenter={true}
            />
        </section>
    );
}
